import { render, staticRenderFns } from "./ScoreFilterBar.vue?vue&type=template&id=6b0178c2&"
import script from "./ScoreFilterBar.vue?vue&type=script&lang=ts&"
export * from "./ScoreFilterBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports